module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Leslie Witz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Leslie Witz is Associate Professor of History at the University of the Western Cape.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6VnNns/tc-custom/9780253028310.jpg?1728155885440",
      "alt": "This image is the cover for the book Apartheid's Festival, African Systems of Thought"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Apartheid's Festival, African Systems of Thought\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Apartheid's Festival highlights the conflicts and debates that surrounded the 1952 celebration of the 300th anniversary of the landing of Jan Van Riebeeck and the founding of Cape Town, South Africa. Taking place at the height of the apartheid era, the festival was viewed by many as an opportunity for the government to promote its nationalist, separatist agenda in grand fashion. Leslie Witz's fine-grained examination of newspapers, brochures, pamphlets, and advertising materials reveals the expectations of the festival planners as well as how the festival was engineered, historical figures were reconstructed, and the ANC and other anti-apartheid organizations mounted opposition to it. While laying open the darker motives of the apartheid regime, Witz shows that the production of local history is part of a global process forged by the struggle between colonialism and resistance. Readers interested in South Africa, representations of nationalism, and the making of public history will find Apartheid's Festival to be an important study of a society in transition.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0